/* eslint-disable import/prefer-default-export */
import axios from '@/api';


// get all user
function getCalendar(id, year, month) {
  return axios.get(`minor/${id}/calendar/${month}/${year}`)
  .then(response => response.data)
  .catch(error => Promise.reject(error));
}

export const calendarService = {
  getCalendar,
};
